// extracted by mini-css-extract-plugin
module.exports = {"table-level-wrapper":"TableLevel_table-level-wrapper__1cIcl"};